import { BackLink } from '@/components/BackLink';
import { Heading } from '@/components/Heading';
import { SPACE, T } from '@/design/tokens';

export function NotFound() {
  return (
    <main
      style={{
        minHeight: '100dvh',
        display: 'grid',
        placeItems: 'center',
        background: T.bg,
        color: T.text,
        padding: SPACE.lg,
      }}
    >
      <div style={{ textAlign: 'center', maxWidth: 360 }}>
        <Heading level={1} size="xxl">
          Not here
        </Heading>
        <p style={{ color: T.textMuted, marginTop: SPACE.md, lineHeight: 1.6 }}>
          We couldn't find that page. It might have been moved, or the link was off.
        </p>
        <div style={{ marginTop: SPACE.lg }}>
          <BackLink to="/vehicles">← garage</BackLink>
        </div>
      </div>
    </main>
  );
}
